import VideoCard from './VideoCard';

const VideoGrid = () => {
  const videos = [
    {
      id: '1',
      title: 'Market Outlook 2024: What Investors Need to Know',
      network: 'Fox News',
      date: 'March 15, 2024',
      thumbnail: 'https://img.youtube.com/vi/S8rJq0I6M20/maxresdefault.jpg',
      videoId: 'S8rJq0I6M20',
      topic: 'Market Analysis'
    },
    {
      id: '2',
      title: 'Federal Reserve Policy Impact on Markets',
      network: 'Fox News',
      date: 'February 28, 2024',
      thumbnail: 'https://img.youtube.com/vi/p0g7PwSZMU0/maxresdefault.jpg',
      videoId: 'p0g7PwSZMU0',
      topic: 'Federal Policy'
    },
    {
      id: '3',
      title: 'Tech Stocks: Navigating the Current Landscape',
      network: 'CBS Detroit',
      date: 'February 15, 2024',
      thumbnail: 'https://img.youtube.com/vi/-Wjtc6w5FT0/maxresdefault.jpg',
      videoId: '-Wjtc6w5FT0',
      topic: 'Technology'
    },
    {
      id: '4',
      title: 'Estate Planning Essentials for 2024',
      network: 'CBS Detroit',
      date: 'January 30, 2024',
      thumbnail: 'https://img.youtube.com/vi/g03e1BiofnA/maxresdefault.jpg',
      videoId: 'g03e1BiofnA',
      topic: 'Estate Planning'
    },
    {
      id: '5',
      title: 'Healthcare Costs and Retirement Planning',
      network: 'Fox News',
      date: 'January 12, 2024',
      thumbnail: 'https://img.youtube.com/vi/hixxYomgJMU/maxresdefault.jpg',
      videoId: 'hixxYomgJMU',
      topic: 'Healthcare'
    },
    {
      id: '6',
      title: 'Municipal Bonds in Rising Rate Environment',
      network: 'Fox News',
      date: 'December 20, 2023',
      thumbnail: 'https://img.youtube.com/vi/eZ4qXofw-Qc/maxresdefault.jpg',
      videoId: 'eZ4qXofw-Qc',
      topic: 'Fixed Income'
    },
    {
      id: '7',
      title: 'Investment Strategies for Volatile Markets',
      network: 'CBS Detroit',
      date: 'December 10, 2023',
      thumbnail: 'https://img.youtube.com/vi/RuIPABZDa7w/maxresdefault.jpg',
      videoId: 'RuIPABZDa7w',
      topic: 'Investment Strategy'
    },
    {
      id: '8',
      title: 'Retirement Income Planning Essentials',
      network: 'Fox News',
      date: 'November 25, 2023',
      thumbnail: 'https://img.youtube.com/vi/0TDHXGkkyJM/maxresdefault.jpg',
      videoId: '0TDHXGkkyJM',
      topic: 'Retirement Planning'
    },
    {
      id: '9',
      title: 'Tax Efficient Portfolio Management',
      network: 'Fox Live',
      date: 'November 15, 2023',
      thumbnail: 'https://img.youtube.com/vi/Hg_5XuwJ1Tk/maxresdefault.jpg',
      videoId: 'Hg_5XuwJ1Tk',
      topic: 'Tax Strategy'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
          Featured TV Appearances
        </h2>
        <p className="text-center text-gray-600 mb-12 text-lg">
          Watch my latest insights on major financial networks
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGrid;